import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
const RestrictedFiltersViewState = props => {
  const {
    message
  } = props;
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    blockSize: "100%",
    inlineSize: "100%",
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(EmptyState, {
      layout: "vertical",
      primaryContent: message || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.RestrictedFiltersViewState.message"
      }),
      reverseOrder: true,
      secondaryContent: /*#__PURE__*/_jsx(Illustration, {
        name: "lock",
        width: "150px",
        margin: "auto"
      }),
      secondaryContentWidth: 200,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.RestrictedFiltersViewState.title"
      })
    })
  });
};
export default RestrictedFiltersViewState;